@import ../../styles/helpers

.searchContainer
    display: flex
    position: relative
    height: 100%
    width: 100%
    max-width: 580px
    margin-bottom: 9px
    +m
        max-width: none
.icon
    fill: $dark_icon
    width: calc($internal_icon + 7px)
    height: calc($internal_icon + 7px)
    position: absolute
    top: 50%
    transform: translateY(-50%)
    right: 10px
    padding: 7.5px
    
    border-radius: 100%
    +m
        width: calc($internal_icon + 5px)
        height: calc($internal_icon + 5px)
.input
    width: 100%
    height: 63px
    background: none
    border-radius: 10px
    padding: 12px 80px 12px 20px
    color: #FFFFFF
    background-color: $bordercolor
    transition: border-color .2s
    height: 100%
    +body
    font-size: 17px
    &::placeholder
        color: white
        opacity: 0.6

.searchBtn
    background-color: $dark_icon_background
    position: absolute
    top: 50%
    transform: translateY(-50%)
    right: 10px
    font-size: 20px
    padding:  calc( $external_margin / 2 ) $external_margin
    border-radius: $border_radius_big
    color: white
    +body-2
